export default "__VITE_ASSET__Df0UEZhs__"